var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../interface/IVueDialog";
import CommonService from "../api/CommonService";
import { ESendCodeType } from "../enum/ESendCodeType";
import RegexStr from "../common/RegexStr";
var phoneRegex = new RegExp(RegexStr.mobile);
var Register = (function (_super) {
    __extends(Register, _super);
    function Register() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            register_type: 1,
            invitationCode: "",
            company: '',
            license: '',
            id_card: '',
            nicknime: '',
            phone: '',
            code: '',
            pwd: '',
            confirm_pwd: '',
            position: '',
            agreed: false,
            goods_type_id: [],
            provide_city_id: [],
            register_from: 1
        };
        _this.isValid = false;
        _this.canGetCode = true;
        _this.remainTime = 60;
        _this.timer = null;
        _this.invite_code_list = [];
        _this.categoryList = [];
        _this.serviceCityList = [];
        return _this;
    }
    Register.prototype.created = function () {
        var _this = this;
        this.service = CommonService.getInstance();
        if (this.registercode) {
            this.formData.invitationCode = this.registercode;
        }
        this.formData.phone = this.phone;
        this.service.getOperateCategory({
            level: 3
        }).then(function (res) {
            _this.categoryList = res.data.data;
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
        this.service.getArea().then(function (res) {
            var area = [res.data.data[0]];
            _this.serviceCityList = area;
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    Register.prototype.normalizer = function (id, name) {
        if (id === void 0) { id = "id"; }
        if (name === void 0) { name = "name"; }
        return function (node) { return ({
            id: node[id],
            label: node[name],
            children: node.children,
        }); };
    };
    Register.prototype.close = function () {
        this.$closeDialog();
    };
    Register.prototype.filterPhone = function () {
        this.formData.phone = this.formData.phone.replace(/[^0-9]/g, '');
        if (this.formData.phone.length > 11) {
            this.formData.phone = this.formData.phone.substring(0, 11);
        }
    };
    Register.prototype.validateCode = function () {
        var _this = this;
        this.formData.code = this.formData.code.replace(/[^0-9]/g, '');
        if (this.formData.code.length > 6) {
            this.formData.code = this.formData.code.slice(0, 6);
        }
        if (this.formData.code.length === 6) {
            this.service.verifyCode({ phone: this.formData.phone, sms_code: this.formData.code, type: ESendCodeType.register }).then(function (res) {
                _this.invite_code_list = res.data.data.invite_code_list;
                _this.isValid = true;
                _this.clearTimer();
            }, function (error) {
                _this.$message.error(error.message);
            });
        }
    };
    Register.prototype.filterField = function (fieldName) {
        this.formData[fieldName] = this.formData[fieldName].replace(/\s/g, '');
    };
    Register.prototype.sendCode = function () {
        var _this = this;
        if (this.timer)
            return;
        if (!phoneRegex.test(this.formData.phone)) {
            this.$message.error('手机号格式不正确！');
            return;
        }
        this.service.sendCode({ phone: this.formData.phone, type: ESendCodeType.register }).then(function (res) {
            _this.$message.success('发送成功！');
        }, function (error) {
            _this.$message.error(error.message);
        });
        this.canGetCode = false;
        this.isValid = false;
        this.timer = setInterval(function () {
            _this.remainTime--;
            if (_this.remainTime === 0) {
                _this.clearTimer();
            }
        }, 1000);
    };
    Register.prototype.clearTimer = function () {
        clearInterval(this.timer);
        this.timer = null;
        this.remainTime = 60;
        this.canGetCode = true;
    };
    Register.prototype.save = function () {
        var _this = this;
        this.$validator.validateScopes().then(function (res) {
            if (!res) {
                _this.$message.error("请填写所有必填字段，并且按字段格式要求填写");
                return;
            }
            if (_this.formData.agreed) {
                var params = {
                    register_type: _this.formData.register_type,
                    invite_code: _this.formData.invitationCode,
                    supplier_name: _this.formData.company,
                    supplier_license_code: _this.formData.license,
                    id_card: _this.formData.id_card,
                    account_nickname: _this.formData.nicknime,
                    phone: _this.formData.phone,
                    password: _this.formData.pwd,
                    account_position: _this.formData.position,
                    smscode: _this.formData.code,
                    goods_type_id: _this.formData.goods_type_id.join(","),
                    provide_city_id: _this.formData.provide_city_id.join(","),
                    register_from: _this.formData.register_from,
                    unionid: _this.unionid,
                    openid: _this.openid
                };
                _this.service.register(params).then(function (res) {
                    _this.close();
                    _this.$alert('您的注册申请已提交成功！', '提示');
                    window._czc.push(["_trackEvent", '注册', '提交注册']);
                }, function (error) {
                    _this.$message.error(error.message);
                });
            }
        });
    };
    Register = __decorate([
        Component
    ], Register);
    return Register;
}(VueDialog));
export default Register;
